import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { toast } from '@/components/ui/use-toast';
import { mdmDeviceSyncSettingsQueryOptions } from '@/features/app-integration/query/mdm-device-sync';
import { defaultNS, legacyT } from '@/lib/i18n';
import { remainingTimeToday } from '@/lib/query';
import { sectionId } from '../-shared/components/sections/constants';
import { getSoftware } from '../../-query/api';
import { softwareKey } from '../../-query/key';
import { resolveAdminConsentCallbackEffect } from './-admin-consent-callback';
import { IntegrationSettingsSearchSchema } from './-schema';

// 連携なしは role へ。render 中の throw redirect は CatchBoundary が errorComponent に渡すため beforeLoad で判定する。
export const Route = createFileRoute('/_staff/software/$id/_$id/settings/integration/')({
  validateSearch: zodValidator(IntegrationSettingsSearchSchema),
  beforeLoad: async ({
    params,
    search,
    context
  }) => {
    const software = await context.queryClient.ensureQueryData({
      queryKey: softwareKey.contract(params.id),
      queryFn: () => getSoftware(params.id),
      staleTime: remainingTimeToday()
    });
    if (software.appIntegrationId === null) {
      throw redirect({
        to: '/software/$id/settings/role',
        params
      });
    }

    // Admin Consent callback（result があるときだけ toast / invalidate してクエリを除去）
    if (search.result == null) {
      return;
    }
    const effect = resolveAdminConsentCallbackEffect(params.id, search);
    if (effect.type === 'success') {
      await context.queryClient.invalidateQueries({
        queryKey: mdmDeviceSyncSettingsQueryOptions(params.id).queryKey
      });
      toast({
        description: legacyT('pages.profile.app.settings.mdmDeviceSync.toast.connectSuccess', {
          ns: defaultNS
        })
      });
    } else if (effect.type === 'error') {
      toast({
        variant: 'destructive',
        description: effect.message || legacyT('pages.profile.app.settings.mdmDeviceSync.toast.connectError', {
          ns: defaultNS
        })
      });
    }

    // softwareId 不一致（none）でもクエリは必ず除去する
    throw redirect({
      to: '/software/$id/settings/integration',
      params: {
        id: params.id
      },
      hash: sectionId.AUTHENTICATION,
      search: {}
    });
  }
});